import { TimePicker } from 'antd';
import { styled } from 'styled-components';

export const StyledTimePicker = styled(TimePicker)`
  .ant-picker-input {
    > input {
      color: ${props => props.theme.colors.secondary.main.text}!important;
    }
    input::placeholder {
      color: ${props => props.theme.colors.secondary.main.text}!important;
    }
  }

  &.ant-picker {
    background-color: transparent !important;
    border: 1px solid ${props => props.theme.colors.neutral.light.border}!important;
    color: ${props => props.theme.colors.secondary.main.text} !important;
  }
  &.ant-picker:focus-within {
    background-color: ${props => props.theme.colors.neutral.light.contentBg}!important;
    border: 1px solid ${props => props.theme.colors.info.main.border}!important;
  }
  &.ant-picker:hover {
    border: 1px solid ${props => props.theme.colors.info.main.border}!important;
  }
  &.ant-picker-disabled,
  &.ant-picker-disabled:hover {
    background-color: ${props => props.theme.colors.neutral.light.surfaceBg}!important;
    background: ${props => props.theme.colors.neutral.light.surfaceBg}!important;
    border: 1px solid ${props => props.theme.colors.neutral.light.border}!important;
    input {
      color: ${props => props.theme.colors.info.main.text}!important;
    }
  }
  .ant-picker-ok {
    > button {
      background: linear-gradient(
        90deg,
        ${props => props.theme.colors.success.main.filled} -53.15%,
        ${props => props.theme.colors.info.main.filled} 100%
      ) !important;
    }
  }
`;

export const StyledTimeRangePicker = styled(TimePicker.RangePicker)`
  .ant-picker-input {
    > input {
      color: ${props => props.theme.colors.secondary.main.text}!important;
    }
    input::placeholder {
      color: ${props => props.theme.colors.secondary.main.text}!important;
    }
  }

  .ant-picker-suffix {
    color: ${props => props.theme.colors.secondary.main.text}!important;
  }

  &.ant-picker {
    background-color: transparent !important;
    border: 1px solid ${props => props.theme.colors.neutral.light.border}!important;
    color: ${props => props.theme.colors.secondary.main.text} !important;
  }
  &.ant-picker:focus-within {
    background-color: ${props => props.theme.colors.neutral.light.contentBg}!important;
    border: 1px solid ${props => props.theme.colors.info.main.border}!important;
  }
  &.ant-picker:hover {
    border: 1px solid ${props => props.theme.colors.info.main.border}!important;
  }
  &.ant-picker-disabled,
  &.ant-picker-disabled:hover {
    background-color: ${props => props.theme.colors.neutral.light.surfaceBg}!important;
    background: ${props => props.theme.colors.neutral.light.surfaceBg}!important;
    border: 1px solid ${props => props.theme.colors.neutral.light.border}!important;
    input {
      color: ${props => props.theme.colors.info.main.text}!important;
    }
    .ant-picker-suffix {
      background-color: rgb(235, 244, 255) !important;
    }
  }
  .ant-picker-ok {
    > button {
      background: linear-gradient(
        90deg,
        ${props => props.theme.colors.success.main.filled} -53.15%,
        ${props => props.theme.colors.info.main.filled} 100%
      ) !important;
    }
  }
`;

export const StyledTimePickerPanel = styled.div`
  .ant-picker-ok {
    > button {
      background: ${props => props.theme.colors.primary.main.filled} !important;
      color: ${props => props.theme.colors.neutral.light.contentBg}!important;
    }
  }
`;
